(function () {
  function toArray(value) {
    if (Array.isArray(value)) return value;
    if (!value) return [];
    if (typeof value === 'string') return value.split(',').map(function (item) { return item.trim(); }).filter(Boolean);
    return [];
  }

  function normalizeRecipe(raw) {
    var recipe = raw || {};
    recipe.prepMin = Number(recipe.prepMin || 0);
    recipe.cookMin = Number(recipe.cookMin || 0);
    recipe.restMin = Number(recipe.restMin || 0);
    recipe.serves = Number(recipe.serves || 4);
    recipe.tags = toArray(recipe.tags);
    recipe.equipment = toArray(recipe.equipment);
    recipe.tips = toArray(recipe.tips);
    recipe.ingredients = Array.isArray(recipe.ingredients) ? recipe.ingredients : [];
    recipe.instructions = Array.isArray(recipe.instructions) ? recipe.instructions : [];
    return recipe;
  }

  function formatMin(value) {
    var min = Number(value || 0);
    if (!min) return '-';
    if (min < 60) return min + ' min';
    var h = Math.floor(min / 60);
    var rem = min % 60;
    return rem ? h + 'h ' + rem + 'm' : h + 'h';
  }

  function scaleQty(qty, factor) {
    var n = Number(qty || 0);
    if (!n) return n;
    var scaled = n * factor;
    if (scaled >= 10) return Math.round(scaled);
    return Math.round(scaled * 4) / 4;
  }

  function formatQty(qty) {
    var n = Number(qty || 0);
    if (!n) return '';
    var whole = Math.floor(n);
    var frac = n - whole;
    var fractions = { 0.25: '1/4', 0.5: '1/2', 0.75: '3/4', 0.33: '1/3', 0.67: '2/3', 0.125: '1/8' };
    var keys = Object.keys(fractions).map(Number);
    var best = 0;
    keys.forEach(function (k) {
      if (Math.abs(k - frac) < Math.abs(best - frac)) best = k;
    });
    if (Math.abs(best - frac) < 0.05) {
      if (whole === 0) return fractions[best];
      if (best === 0) return String(whole);
      return whole + ' ' + fractions[best];
    }
    return String(n);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function init(section) {
    if (!section || section.dataset.recipesBound === 'true') return;
    section.dataset.recipesBound = 'true';

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-recipe-card]'));
    var statCount = section.querySelector('#pc-rec-stat-count-' + section.dataset.sectionId);
    if (statCount) statCount.textContent = cards.length;

    var scripts = Array.prototype.slice.call(section.querySelectorAll('[data-recipe-json]'));
    var recipes = {};
    scripts.forEach(function (node) {
      try {
        var parsed = JSON.parse(node.textContent);
        if (parsed && parsed.id) recipes[parsed.id] = normalizeRecipe(parsed);
      } catch (_) {}
    });

    var config = { categories: [] };
    var configNode = section.querySelector('[data-rec-config]');
    if (configNode) {
      try {
        config = JSON.parse(configNode.textContent) || config;
      } catch (_) {}
    }

    var state = {
      cat: 'all',
      time: 'any',
      diff: 'any',
      sort: 'featured',
      search: ''
    };

    var searchInput = section.querySelector('[data-rec-search]');
    var timeSelect = section.querySelector('[data-rec-time]');
    var diffSelect = section.querySelector('[data-rec-diff]');
    var sortSelect = section.querySelector('[data-rec-sort]');
    var catsWrap = section.querySelector('[data-rec-cats]');
    var activeCount = section.querySelector('[data-rec-active-count]');
    var emptyState = section.querySelector('[data-rec-empty]');
    var modalBackdrop = section.querySelector('[data-rec-modal-backdrop]');
    var modalContent = section.querySelector('[data-rec-modal-content]');
    var submitBackdrop = section.querySelector('[data-rec-submit-modal]');
    var submitForm = section.querySelector('[data-rec-submit-form]');
    var submitSuccess = section.querySelector('[data-rec-submit-success]');

    var currentRecipe = null;
    var currentServings = 0;
    var currentView = 'quick';

    function parseCard(card) {
      return {
        node: card,
        id: card.dataset.recipeHandle,
        title: (card.dataset.recipeTitle || '').toLowerCase(),
        category: (card.dataset.recipeCategory || '').toLowerCase(),
        difficulty: card.dataset.recipeDifficulty || '',
        prep: Number(card.dataset.recipePrep || 0),
        cook: Number(card.dataset.recipeCook || 0),
        total: Number(card.dataset.recipeTotal || 0)
      };
    }

    var cardData = cards.map(parseCard);

    function diffRank(value) {
      return { Easy: 1, Medium: 2, Advanced: 3 }[value] || 4;
    }

    function matchesTime(card) {
      if (state.time === 'quick') return card.total < 30;
      if (state.time === 'med') return card.total >= 30 && card.total <= 60;
      if (state.time === 'long') return card.total > 60;
      return true;
    }

    function matchesSearch(card) {
      if (!state.search) return true;
      if (card.title.indexOf(state.search) > -1) return true;
      var recipe = recipes[card.id];
      if (!recipe) return false;
      if (String(recipe.cut || '').toLowerCase().indexOf(state.search) > -1) return true;
      if (String(recipe.tagline || '').toLowerCase().indexOf(state.search) > -1) return true;
      var ingredientHit = false;
      (recipe.ingredients || []).forEach(function (group) {
        (group.items || []).forEach(function (item) {
          if (String(item.item || '').toLowerCase().indexOf(state.search) > -1) ingredientHit = true;
        });
      });
      return ingredientHit;
    }

    function applyFilters() {
      var list = cardData.filter(function (card) {
        if (state.cat !== 'all' && card.category !== state.cat) return false;
        if (state.diff !== 'any' && card.difficulty !== state.diff) return false;
        if (!matchesTime(card)) return false;
        if (!matchesSearch(card)) return false;
        return true;
      });

      if (state.sort === 'quick') list.sort(function (a, b) { return a.total - b.total; });
      else if (state.sort === 'easy') list.sort(function (a, b) { return diffRank(a.difficulty) - diffRank(b.difficulty); });
      else if (state.sort === 'alpha') list.sort(function (a, b) { return a.title.localeCompare(b.title); });

      cards.forEach(function (card) { card.hidden = true; });
      list.forEach(function (entry) {
        entry.node.hidden = false;
        if (entry.node.parentNode) entry.node.parentNode.appendChild(entry.node);
      });

      if (activeCount) activeCount.textContent = list.length + (list.length === 1 ? ' recipe' : ' recipes');
      if (emptyState) emptyState.hidden = list.length > 0;
    }

    function countByCategory(id) {
      if (id === 'all') return cards.length;
      return cardData.filter(function (card) { return card.category === id; }).length;
    }

    function renderCats() {
      if (!catsWrap) return;
      var categories = Array.isArray(config.categories) ? config.categories : [];
      if (!categories.length) {
        categories = [{ id: 'all', label: 'All Recipes' }];
      }

      catsWrap.innerHTML = categories.map(function (cat) {
        var id = (cat.id || '').toLowerCase();
        var count = countByCategory(id);
        return '<button type="button" class="pc-rec-cat' + (state.cat === id ? ' active' : '') + '" data-rec-cat="' + escapeHtml(id) + '">' +
          escapeHtml(cat.label || id) + '<span class="count">' + count + '</span></button>';
      }).join('');
    }

    function openModal() {
      if (!modalBackdrop) return;
      modalBackdrop.hidden = false;
      modalBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      if (!modalBackdrop) return;
      modalBackdrop.classList.remove('is-open');
      modalBackdrop.hidden = true;
      if (!submitBackdrop || !submitBackdrop.classList.contains('is-open')) document.body.style.overflow = '';
      currentRecipe = null;
      var url = new URL(window.location.href);
      url.searchParams.delete('r');
      history.replaceState({}, '', url.toString());
    }

    function renderQuickView(recipe, factor) {
      var flat = [];
      recipe.ingredients.forEach(function (group) {
        (group.items || []).forEach(function (item) { flat.push(item); });
      });

      var ingredients = flat.map(function (item) {
        var qty = scaleQty(item.qty, factor);
        var qtyStr = qty ? formatQty(qty) + (item.unit ? ' ' + item.unit : '') : '';
        return '<li>' + (qtyStr ? '<strong>' + escapeHtml(qtyStr) + '</strong> ' : '') + escapeHtml(item.item || '') + (item.note ? ' <em>(' + escapeHtml(item.note) + ')</em>' : '') + '</li>';
      }).join('');

      var steps = recipe.instructions.map(function (step) {
        return '<li>' + escapeHtml(step.text || '') + '</li>';
      }).join('');

      return '<div class="pc-rec-quick-view"><h3>What You\'ll Need</h3><ul>' + ingredients + '</ul><h3>The Method</h3><ol>' + steps + '</ol></div>';
    }

    function renderFullView(recipe, factor) {
      var ingredients = recipe.ingredients.map(function (group) {
        var items = (group.items || []).map(function (item) {
          var qty = scaleQty(item.qty, factor);
          var qtyStr = qty ? formatQty(qty) + (item.unit ? ' ' + item.unit : '') : '';
          return '<li class="pc-rec-ingredient"><span class="qty">' + escapeHtml(qtyStr) + '</span><span class="item">' + escapeHtml(item.item || '') + (item.note ? '<small>' + escapeHtml(item.note) + '</small>' : '') + '</span></li>';
        }).join('');
        return '<h4>' + escapeHtml(group.group || '') + '</h4><ul class="pc-rec-ingredients">' + items + '</ul>';
      }).join('');

      var steps = recipe.instructions.map(function (step) {
        return '<li class="pc-rec-step">' + escapeHtml(step.text || '') + (step.tip ? '<div class="pc-rec-step-tip">' + escapeHtml(step.tip) + '</div>' : '') + '</li>';
      }).join('');

      var equipment = recipe.equipment.length
        ? '<div class="pc-rec-equipment"><strong>Equipment</strong> ' + escapeHtml(recipe.equipment.join(' | ')) + '</div>'
        : '';

      var tips = recipe.tips.length
        ? '<div class="pc-rec-tips-block"><h4>Pro Tips</h4><ul>' + recipe.tips.map(function (tip) { return '<li>' + escapeHtml(tip) + '</li>'; }).join('') + '</ul></div>'
        : '';

      return '<div class="pc-rec-full-view"><div class="pc-rec-col"><h3>Ingredients</h3>' + ingredients + equipment + '</div><div class="pc-rec-col"><h3>Method</h3><ol class="pc-rec-steps">' + steps + '</ol>' + tips + '</div></div>';
    }

    function renderRecipeModal() {
      if (!currentRecipe || !modalContent) return;
      var recipe = currentRecipe;
      var factor = currentServings / (recipe.serves || 1);
      var total = (recipe.prepMin || 0) + (recipe.cookMin || 0);
      var view = currentView === 'full' ? renderFullView(recipe, factor) : renderQuickView(recipe, factor);

      modalContent.innerHTML =
        '<div class="pc-rec-modal-photo" style="background-image:url(\'' + escapeHtml(recipe.image || '') + '\')">' +
          '<button class="pc-rec-modal-close" type="button" data-rec-close aria-label="Close">✕</button>' +
          '<div class="pc-rec-modal-photo-content">' +
            '<span class="cat">' + escapeHtml(recipe.category || 'Recipe') + (recipe.cut ? ' · ' + escapeHtml(recipe.cut) : '') + '</span>' +
            '<h2>' + escapeHtml(recipe.title || '') + '</h2>' +
          '</div>' +
        '</div>' +
        '<div class="pc-rec-modal-body">' +
          '<p class="pc-rec-desc">' + escapeHtml(recipe.description || '') + '</p>' +
          (recipe.tags.length ? '<div class="pc-rec-tags">' + recipe.tags.map(function (tag) { return '<span class="pc-rec-tag">' + escapeHtml(tag) + '</span>'; }).join('') + '</div>' : '') +
          '<div class="pc-rec-modal-stats">' +
            '<div class="pc-rec-modal-stat"><div class="lbl">Difficulty</div><div class="val">' + escapeHtml(recipe.difficulty || '-') + '</div></div>' +
            '<div class="pc-rec-modal-stat"><div class="lbl">Prep</div><div class="val">' + formatMin(recipe.prepMin) + '</div></div>' +
            '<div class="pc-rec-modal-stat"><div class="lbl">Cook</div><div class="val">' + formatMin(recipe.cookMin) + '</div></div>' +
            '<div class="pc-rec-modal-stat"><div class="lbl">Total</div><div class="val">' + formatMin(total) + '</div></div>' +
          '</div>' +
          '<div class="pc-rec-scaler">' +
            '<span class="lbl">Servings</span>' +
            '<span class="pc-rec-servings">' + currentServings + '</span>' +
            '<div class="pc-rec-scale-btns">' +
              '<button type="button" class="pc-rec-scale-btn' + (factor === 0.5 ? ' active' : '') + '" data-rec-servings="' + Math.max(1, Math.round(recipe.serves * 0.5)) + '">1/2x</button>' +
              '<button type="button" class="pc-rec-scale-btn' + (factor === 1 ? ' active' : '') + '" data-rec-servings="' + recipe.serves + '">1x</button>' +
              '<button type="button" class="pc-rec-scale-btn' + (factor === 2 ? ' active' : '') + '" data-rec-servings="' + (recipe.serves * 2) + '">2x</button>' +
              '<button type="button" class="pc-rec-scale-btn' + (factor === 3 ? ' active' : '') + '" data-rec-servings="' + (recipe.serves * 3) + '">3x</button>' +
            '</div>' +
            '<button type="button" class="pc-rec-print" data-rec-print>🖨 Print</button>' +
          '</div>' +
          '<div class="pc-rec-view-toggle">' +
            '<button type="button" class="pc-rec-view-btn' + (currentView === 'quick' ? ' active' : '') + '" data-rec-view="quick">Quick View</button>' +
            '<button type="button" class="pc-rec-view-btn' + (currentView === 'full' ? ' active' : '') + '" data-rec-view="full">Full Detail</button>' +
          '</div>' +
          view +
          (recipe.primeCutsNote ? '<div class="pc-rec-pc-note"><span class="lbl">From Prime Cuts</span><p>' + escapeHtml(recipe.primeCutsNote) + '</p></div>' : '') +
        '</div>';
    }

    function openRecipe(handle) {
      var recipe = recipes[handle];
      if (!recipe) return false;
      currentRecipe = recipe;
      currentServings = recipe.serves || 4;
      currentView = 'quick';
      renderRecipeModal();
      openModal();
      var url = new URL(window.location.href);
      url.searchParams.set('r', handle);
      history.replaceState({}, '', url.toString());
      return true;
    }

    function openSubmit() {
      if (!submitBackdrop) return;
      submitBackdrop.hidden = false;
      submitBackdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeSubmit() {
      if (!submitBackdrop) return;
      submitBackdrop.classList.remove('is-open');
      submitBackdrop.hidden = true;
      if (!modalBackdrop || !modalBackdrop.classList.contains('is-open')) document.body.style.overflow = '';
      if (submitForm) submitForm.reset();
      if (submitForm) submitForm.hidden = false;
      if (submitSuccess) submitSuccess.hidden = true;
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        var handle = card.dataset.recipeHandle;
        if (!handle) return;
        if (openRecipe(handle)) event.preventDefault();
      });
    });

    section.addEventListener('click', function (event) {
      var catBtn = event.target.closest('[data-rec-cat]');
      if (catBtn) {
        state.cat = catBtn.dataset.recCat;
        renderCats();
        applyFilters();
      }

      if (event.target.closest('[data-rec-open-submit]')) {
        openSubmit();
      }

      if (event.target.closest('[data-rec-close-submit]')) {
        closeSubmit();
      }

      if (event.target.closest('[data-rec-close]')) {
        closeModal();
      }

      if (event.target === modalBackdrop) {
        closeModal();
      }

      if (event.target === submitBackdrop) {
        closeSubmit();
      }

      if (event.target.closest('[data-rec-clear]')) {
        state.cat = 'all';
        state.time = 'any';
        state.diff = 'any';
        state.sort = 'featured';
        state.search = '';
        if (searchInput) searchInput.value = '';
        if (timeSelect) timeSelect.value = 'any';
        if (diffSelect) diffSelect.value = 'any';
        if (sortSelect) sortSelect.value = 'featured';
        renderCats();
        applyFilters();
      }
    });

    if (modalContent) {
      modalContent.addEventListener('click', function (event) {
        var servingsBtn = event.target.closest('[data-rec-servings]');
        if (servingsBtn && currentRecipe) {
          currentServings = Math.max(1, Number(servingsBtn.dataset.recServings || currentRecipe.serves || 1));
          renderRecipeModal();
        }

        var viewBtn = event.target.closest('[data-rec-view]');
        if (viewBtn) {
          currentView = viewBtn.dataset.recView;
          renderRecipeModal();
        }

        if (event.target.closest('[data-rec-print]')) {
          window.print();
        }
      });
    }

    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', function (event) {
        if (event.target === modalBackdrop) closeModal();
      });
    }

    if (submitBackdrop) {
      submitBackdrop.addEventListener('click', function (event) {
        if (event.target === submitBackdrop) closeSubmit();
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function (event) {
        state.search = String(event.target.value || '').toLowerCase();
        applyFilters();
      });
    }
    if (timeSelect) {
      timeSelect.addEventListener('change', function (event) {
        state.time = event.target.value;
        applyFilters();
      });
    }
    if (diffSelect) {
      diffSelect.addEventListener('change', function (event) {
        state.diff = event.target.value;
        applyFilters();
      });
    }
    if (sortSelect) {
      sortSelect.addEventListener('change', function (event) {
        state.sort = event.target.value;
        applyFilters();
      });
    }

    if (submitForm) {
      submitForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var data = new FormData(submitForm);
        fetch('/contact#pc-recipe-submission', {
          method: 'POST',
          body: data,
          headers: { Accept: 'text/html' }
        }).then(function () {
          submitForm.hidden = true;
          if (submitSuccess) submitSuccess.hidden = false;
        }).catch(function () {
          submitForm.submit();
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeModal();
      closeSubmit();
    });

    renderCats();
    applyFilters();

    var deepLink = new URL(window.location.href).searchParams.get('r');
    if (deepLink) openRecipe(deepLink);
  }

  function initAll() {
    document.querySelectorAll('.section-pc-recipes .pc-recipes').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.pc-recipes');
    if (root) init(root);
  });
})();
